import { ToolbarPlugin } from "csi/view/ToolbarPlugin";
import declare from "dojo/_base/declare";
import _ from "lodash";
import SharedSpecSectionsSwitchboard from "src/SiteAdmin/SharedSpecSectionsSwitchboard";
import { getMatrixPresence } from "src/SpecificationDataSheet/sharedSectionMatrixService";
import AllComponentsTable from "./AllComponentsTable";

export = declare(SharedSpecSectionsSwitchboard, {
	/**
	 * @override
	 * set it to null so that we can get switchboard relationship from the referenced view
	 */
	switchboardPath: null,

	/**
	 * @override
	 * Don't show the switchboard if SharedSpecSections is empty
	 */
	canShowPlugin(): boolean {
		const toolbar = this as unknown as ToolbarPlugin;
		const view = toolbar.getView() as unknown as typeof AllComponentsTable.prototype;
		const matrixAvailability = getMatrixPresence(view.attributeSpecs);

		// if shared section is not part of the view, no need to show switchboard
		if (!matrixAvailability.specSectionIsAvailable) {
			return false;
		}

		return !_.isEmpty(view.sharedSections);
	},
});